module.exports = __webpack_public_path__ + "img/fig_change_setting-en-US.0e270a87.png";